import { ObjectStatItem } from './ObjectStatItem';

export class ObjectStat {
  constructor(private readonly type: string, private readonly totalCount: number, private readonly stats: ObjectStatItem[]) {}

  getType() {
    return this.type;
  }

  getTotalCount() {
    return this.totalCount;
  }

  getStats() {
    return this.stats;
  }
}
